/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { formatEmptyValue } from '@/utils/assets'
import { normalizeValueArrayToString } from '@/utils/general'
import { getFileTypeIconUrl, setPreviewUrl } from '@/utils/items'

const getCommonValues = (item) => {
  const creators = formatEmptyValue(
    normalizeValueArrayToString(item.creators.map((c) => c.name))
  )
  const publishers = formatEmptyValue(
    normalizeValueArrayToString(item.publishers.map(p => p.name))
  )
  const fileType = normalizeValueArrayToString(item.fileType)

  return {
    assetBatch: formatEmptyValue(item.assetBatch?.name),
    assetId: item.assetId,
    creators,
    fileType,
    id: item.id,
    publishers,
    title: item?.title
  }
}

export const setItemCustomProps = (item) => {
  const {
    assetBatch,
    assetId,
    creators,
    fileType,
    id,
    publishers,
    title
  } = getCommonValues(item)

  const itemDetails = [
    {
      label: 'File type',
      value: fileType
    },
    {
      label: 'Publishers',
      value: publishers
    },
    {
      label: 'Registration Batch',
      value: assetBatch
    },
    {
      label: 'Asset Id',
      value: assetId
    }
  ]
  return {
    creators,
    fileType,
    id,
    imageUrl: setPreviewUrl(item?.coverUrl, fileType),
    itemDetails,
    title
  }
}
export const getItemsPropsForTable = (item) => {
  const {
    assetBatch,
    assetId,
    creators,
    fileType,
    id,
    publishers,
    title
  } = getCommonValues(item)

  return {
    assetBatch,
    assetId,
    creators,
    fileType,
    id,
    publishers,
    title,
    iconUrl: getFileTypeIconUrl(fileType)
  }
}

export const tableColumns = [
  {
    title: '',
    id: 'checkbox'
  },
  {
    title: '',
    id: 'icon'
  },
  {
    title: 'Asset Id',
    id: 'assetId'
  },
  {
    title: 'Title',
    id: 'title'
  },
  {
    title: 'Creators',
    id: 'creators'
  },
  {
    title: 'Publishers',
    id: 'publishers'
  },
  {
    title: 'File Type',
    id: 'fileType'
  },
  {
    title: 'Registration Batch',
    id: 'assetBatch'
  }
]
